// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cron[data-v-c4adb63e]{width:700px;margin:0 auto;margin-top:100px;overflow:inherit}.cron h1[data-v-c4adb63e]{font-size:16px;text-align:center}", ""]);
// Exports
module.exports = exports;
